import { CloudArrowUpIcon } from "@";
import { memo } from "react";

const Progress = ({ show }) => {
  return (
    <div
      className={`relative z-30 inline-flex items-center gap-2.5 rounded-full border border-purple-100 bg-white/90 px-3 py-1.5 shadow-sm shadow-purple-900/5 backdrop-blur-md dark:border-purple-800/40 dark:bg-gray-800/80 ${
        show ? "" : "hidden"
      }`}
    >
      <span className="relative flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-purple-800 to-purple-950 text-white shadow-md shadow-purple-900/25 dark:from-purple-600 dark:to-purple-800">
        {/* Pulse ring */}
        <span
          aria-hidden
          className="absolute inset-0 animate-ping rounded-full bg-purple-500 opacity-30"
        />
        <CloudArrowUpIcon className="relative h-4 w-4 animate-bounce" />
      </span>
      <span className="text-[13px] font-medium text-gray-600 dark:text-gray-300">
        جاري التحميل
      </span>
      <span
        id="progressNumber"
        className="font-mono text-[13px] font-bold tabular-nums text-purple-700 dark:text-purple-300"
      >
        0%
      </span>
    </div>
  );
};

export default memo(Progress);
